"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Exports_1 = require("./Exports");
var Endpoints_1 = require("../Utils/Endpoints");
var Util_1 = require("./Util");
var ScannerInput = /** @class */ (function () {
    function ScannerInput(charset) {
        this.charArray = [];
        this.inputCharArray = [];
        this.logs = [];
        this.lockLogs = false;
        this.transactionId = "";
        this.inputCharArrayIndex = 0;
        this.tryAgainError = "";
        this.genericError = "";
        this.symbolId = "]d1";
        for (var i = 0; i < charset.length; i++) {
            this.charArray.push(charset.charCodeAt(i));
        }
        this.isProcessing = false;
        this.isComplete = false;
        this.inputPreviousLength = 0;
        this.errorCount = 0;
        this.clear();
        //this.tryAgainError = resources.Calibration_ErrorTryAgain;
        //this.genericError = resources.Calibration_GenericError;
    }
    ScannerInput.prototype.hasPrefix = function () {
        var result = true;
        for (var i = 0; i < this.symbolId.length; i++) {
            if (this.inputCharArray[i] !== this.symbolId.charCodeAt(i))
                result = false;
        }
        return result;
    };
    ScannerInput.prototype.clear = function () {
        var n = 1000;
        this.inputCharArray = new Array(n);
        var i = 0;
        while (i < n) {
            this.inputCharArray[i] = 0;
            i++;
        }
        this.inputCharArrayIndex = 0;
        if (!this.lockLogs) {
            this.logs = [];
        }
    };
    ScannerInput.prototype.persistLogs = function () {
        var _this = this;
        this.lockLogs = true;
        Exports_1.getJson(Endpoints_1.default.GetIdentifier).then(function (j) {
            var id = JSON.parse(j);
            console.log("Scan Event Logged: " + id);
            Exports_1.postJson(Endpoints_1.default.PersistScanLogs, JSON.stringify(_this.logs), undefined, undefined, undefined, undefined, new Util_1.TransactionIdRequestHeader(id));
            _this.logs = [];
            _this.lockLogs = false;
        });
    };
    ScannerInput.prototype.log = function (value) {
        if (typeof value === 'string' || value instanceof String) {
            this.logs.push(JSON.stringify(value));
        }
        else if (value instanceof Event) {
            this.logs.push(Util_1.stringifyEvent(value));
        }
        else {
            console.error("tried to log type: " + typeof value);
        }
    };
    ScannerInput.prototype.push = function (value) {
        //console.log(`ScannerInput.Push(${value})`);
        try {
            this.inputCharArray[this.inputCharArrayIndex++] = value;
        }
        catch (e) {
            alert(e.toString());
        }
        this.log("pushed " + value);
    };
    ScannerInput.prototype.pop = function () {
        //console.log(`ScannerInput.Pop()`);
        return this.inputCharArray[--this.inputCharArrayIndex];
    };
    ScannerInput.prototype.peek = function () {
        return this.inputCharArray[this.inputCharArrayIndex - 1];
    };
    ScannerInput.prototype.getInputBytes = function () {
        if (this.inputCharArray.length <= 0 ||
            (this.inputCharArray.length > 0 && Object.prototype.toString.call(this.inputCharArray[0]).slice(8, -1) !== "Number")) {
            return [];
        }
        return this.inputCharArray.slice(0, this.inputCharArrayIndex);
    };
    ScannerInput.prototype.getInput = function (lengthSpecifier) {
        if (lengthSpecifier === void 0) { lengthSpecifier = false; }
        if (this.inputCharArray.length <= 0) {
            return "";
        }
        var classType = Object.prototype.toString.call(this.inputCharArray[0]).slice(8, -1);
        var charactersOut = "" + (lengthSpecifier ? "[" + this.inputCharArrayIndex.toString() + "] : " : "");
        if (classType !== "Number") {
            if (classType === "KeyboardEvent") {
                for (var i = 0; i < this.inputCharArrayIndex; i++) {
                    var modifiers = this.inputCharArray[i].shiftKey ? 1 : 0;
                    modifiers += this.inputCharArray[i].ctrlKey ? 2 : 0;
                    modifiers += this.inputCharArray[i].altKey ? 4 : 0;
                    modifiers += this.inputCharArray[i].metaKey ? 16 : 0;
                    charactersOut += (i === 0 ? "" : ",") + "{\"code\":\"" + this.inputCharArray[i].code + "\",\"modifiers\":" + modifiers + "}";
                }
                return "[" + charactersOut + "]";
            }
            return [];
        }
        for (var i = 0; i < this.inputCharArrayIndex; i++) {
            charactersOut += "" + (i === 0 ? "" : ",") + this.inputCharArray[i].toString();
        }
        return charactersOut;
    };
    ScannerInput.prototype.process = function ( /*mapping*/) {
        var _this = this;
        //var localMapping = Object.assign(mapping);
        this.inputPreviousLength = 0;
        this.isProcessing = true;
        var result = new Promise(function (resolve, reject) {
            var interval = window.setInterval(function () {
                if (_this.inputCharArray.length > _this.inputPreviousLength) {
                    _this.inputPreviousLength = _this.inputCharArray.length;
                }
                else {
                    if (_this.inputCharArray.length >= _this.charArray.length) {
                        if (_this.inputCharArray[_this.inputCharArray.length - 1] === 13) {
                            _this.inputCharArray.pop();
                        }
                        if (_this.hasPrefix()) {
                            _this.inputCharArray = _this.inputCharArray.slice(_this.symbolId.length);
                        }
                        if (_this.charArray.length === _this.inputCharArray.length) {
                            //if (!this.inputCharArray.isUnique(46)) {
                            //    reject(this.errorCount < 3 ? this.tryAgainError : this.genericError);
                            //    this.errorCount++;
                            //} else {
                            //    this.inputCharArray.map((v, i) => {
                            //        localMapping[v] = this.charArray[i];
                            //    });
                            //    this.isComplete = true;
                            //    resolve(localMapping);
                            //}
                        }
                        else {
                            reject(_this.genericError);
                        }
                    }
                    _this.isProcessing = false;
                    _this.inputCharArray = [];
                    clearInterval(interval);
                }
            }, 150);
        });
        return result;
    };
    return ScannerInput;
}());
exports.ScannerInput = ScannerInput;
//# sourceMappingURL=ScannerInput.js.map